module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_up_24px.bd2a08d7.svg";